import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type SearchConstituent from '@/types/api/SearchConstituent';
import { formatDate } from '@/utils/dates';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const dobColumn = {
  columnKey: ConstituentSearchColumn.DATE_OF_BIRTH,
  headerName: 'BIRTHDAY_LABEL',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) => {
    const value = formatDate(constituent.dob);

    return value || null;
  },
};

export default dobColumn;
